import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'environment';
import { Rest } from '../../backend/rest';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {

  public error: any;
  public nordfab: boolean = environment.nordfab();

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private backend: Rest
  ) { }

  ngOnInit() {

    this.activatedRoute.queryParams.subscribe(params => {
      if (params['error']) {
        this.error = params['error'];
      } else if (!params['session'] || !params['token']) {
        // TODO: Into global config
        let url = environment.backendUrl + environment.loginPath;
        if (params['returnUrl']) {
          url = url + (url.indexOf('?') > -1 ? '&' : '?') + 'returnUrl=' + params['returnUrl'];
        }
        window.location.href = url;
      } else if (params['returnUrl']) {
        this.backend.setSessionToken(params['session'], params['token']);
        this.router.navigate([params['returnUrl']]);
      } else {
        this.backend.setSessionToken(params['session'], params['token']);
        this.router.navigate(['/nederman/companies']);
      }
    });

  }

}
